<template>
  <div style="text-align: center;">
    <h5>校级开课汇总查询</h5>
    <el-select v-model="selectedSemester" placeholder="请选择学期" style="width: 200px; margin-bottom: 20px;">
      <el-option
        v-for="(item, index) in semesters"
        :key="item.uuid"
        :label="item.name"
        :value="item.uuid">
        <span>{{ item.name }}</span>
        <template v-if="index === 0">
          <el-tag type="primary" style="margin-left: 10px;">当前学期</el-tag>
        </template>
      </el-option>
    </el-select>
    <el-button type="primary" @click="fetchStudents">查询</el-button>
    <el-button type="success" @click="toggleEditMode">{{ editMode ? '退出修改模式' : '进入修改模式' }}</el-button>
    <el-button v-if="editMode" type="primary" @click="saveChanges">保存修改</el-button>
    <el-table :data="students" style="width: 100%; margin-top: 20px;">
      <el-table-column prop="id" label="ID" width="120"></el-table-column>
      <el-table-column label="日期" width="100">
        <template #default="scope">
          <div v-if="editMode">
            <el-input v-model="scope.row.year" size="small" style="width: 50px; display: inline-block;"></el-input>/
            <el-input v-model="scope.row.month" size="small" style="width: 50px; display: inline-block;"></el-input>/
            <el-input v-model="scope.row.day" size="small" style="width: 50px; display: inline-block;"></el-input>
          </div>
          <span v-else>{{ scope.row.year }}/{{ scope.row.month }}/{{ scope.row.day }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="subject" label="学科" width="80">
        <template #default="scope">
          <el-input v-if="editMode" v-model="scope.row.subject" size="small"></el-input>
          <span v-else>{{ scope.row.subject }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="topic" label="课题" width="170">
        <template #default="scope">
          <el-input v-if="editMode" v-model="scope.row.topic" size="small"></el-input>
          <span v-else>{{ scope.row.topic }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="level" label="级别" width="80">
        <template #default="scope">
          <el-input v-if="editMode" v-model="scope.row.level" size="small"></el-input>
          <span v-else>{{ scope.row.level }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="teacher" label="执教者" width="130">
        <template #default="scope">
          <el-input v-if="editMode" v-model="scope.row.teacher" size="small"></el-input>
          <span v-else>{{ scope.row.teacher }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="mentor" label="指导教师">
        <template #default="scope">
          <el-input v-if="editMode" v-model="scope.row.mentor" size="small"></el-input>
          <span v-else>{{ scope.row.mentor }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="type" label="类型" width="80">
        <template #default="scope">
          <el-input v-if="editMode" v-model="scope.row.type" size="small"></el-input>
          <span v-else>{{ scope.row.type }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注">
        <template #default="scope">
          <el-input v-if="editMode" v-model="scope.row.remark" size="small"></el-input>
          <span v-else>{{ scope.row.remark }}</span>
        </template>
      </el-table-column>
      <el-table-column label="上传日期" width="100">
        <template #default="scope">
          <div v-if="editMode">
            <el-input v-model="scope.row.up_year" size="small" style="width: 50px; display: inline-block;"></el-input>/
            <el-input v-model="scope.row.up_month" size="small" style="width: 50px; display: inline-block;"></el-input>/
            <el-input v-model="scope.row.up_day" size="small" style="width: 50px; display: inline-block;"></el-input>
          </div>
          <span v-else>{{ scope.row.up_year }}/{{ scope.row.up_month }}/{{ scope.row.up_day }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150">
        <template #default="scope">
          <el-button size="small" @click="downloadPDF(scope.row)">下载</el-button>
          <el-button size="small" type="danger" @click="confirmDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import axios from 'axios';
import { ElMessage, ElMessageBox } from 'element-plus';

export default {
  data() {
    return {
      students: [],
      semesters: [],
      selectedSemester: null,
      editMode: false,
    };
  },
  mounted() {
    this.fetchSemesters();
  },
  methods: {
    async fetchSemesters() {
      try {
        const response = await axios.get('/api/semesters');
        this.semesters = response.data.semesters;
      } catch (error) {
        ElMessage({
          type: 'error',
          message: '获取学期数据失败',
        });
      }
    },
    async fetchStudents() {
      if (!this.selectedSemester) {
        ElMessage({
          type: 'warning',
          message: '请选择一个学期',
        });
        return;
      }
      try {
        const response = await axios.get(`/api/School_Course_Summary?semesterUuid=${this.selectedSemester}`);
        this.students = response.data;
      } catch (error) {
        ElMessage({
          type: 'error',
          message: '获取课程数据失败',
        });
      }
    },
    toggleEditMode() {
      this.editMode = !this.editMode;
    },
    saveChanges() {
      axios.post('/api/update_school_course_summary', this.students)
        .then(() => {
          ElMessage.success('修改已保存');
          this.editMode = false;
        })
        .catch(error => {
          console.error("保存失败:", error);
          ElMessage.error('保存失败');
        });
    },
    downloadPDF(row) {
      axios({
        url: '/api/download_pdf',
        method: 'POST',
        data: row,
        responseType: 'blob',
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${row.id}-${row.teacher}-${row.topic}.pdf`);
        document.body.appendChild(link);
        link.click();
      }).catch(error => {
        console.error("下载失败:", error);
        ElMessage.error('下载失败');
      });
    },
    confirmDelete(course) {
      ElMessageBox.confirm(
        `确定要删除课程 "${course.topic}" 吗？`,
        '确认删除',
        {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning',
        }
      ).then(() => {
        this.deleteCourse(course);
      }).catch(() => {
        ElMessage.info('删除已取消');
      });
    },
    async deleteCourse(course) {
      try {
        const response = await axios.delete('/api/delete_school_course', {
          data: { id: course.id }
        });
        if (response.data.success) {
          ElMessage.success('删除成功');
          this.students = this.students.filter(item => item.id !== course.id);
        }
      } catch (error) {
        console.error("删除失败:", error);
        ElMessage.error('删除失败');
      }
    }
  }
};
</script>
